<template>
  <div class="prompt-manager">
    <div class="page-header">
      <div>
        <h1>{{ $t('bo.aiPrompts.title') }}</h1>
        <p>{{ $t('bo.aiPrompts.subtitle') }}</p>
      </div>
      <button @click="showCreate = true" class="btn-primary">
        {{ $t('bo.aiPrompts.newPrompt') }}
      </button>
    </div>

    <AiPromptList
      ref="listRef"
      @edit="handleEdit"
      @publish="handlePublish"
      @archive="handleArchive"
      @versions="handleVersions"
    />

    <CreateAiPromptModal
      v-if="showCreate"
      @close="showCreate = false"
      @created="handleCreated"
    />

    <EditAiPromptModal
      v-if="editingId"
      :prompt-id="editingId"
      :show-versions="showingVersions"
      @close="editingId = null; showingVersions = false"
      @updated="handleUpdated"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AiPromptList from './AiPromptList.vue'
import CreateAiPromptModal from './CreateAiPromptModal.vue'
import EditAiPromptModal from './EditAiPromptModal.vue'
import aiPromptService from '@/services/aiPromptService'

const { t } = useI18n()

const showCreate = ref(false)
const editingId = ref(null)
const showingVersions = ref(false)
const listRef = ref(null)

const handleEdit = (id) => {
  editingId.value = id
  showingVersions.value = false
}

const handleVersions = (id) => {
  editingId.value = id
  showingVersions.value = true
}

const handlePublish = async (id) => {
  if (!confirm(t('bo.aiPrompts.confirmPublish'))) return
  try {
    await aiPromptService.publish(id)
    listRef.value?.loadPrompts()
  } catch (e) {
    alert(e.response?.data?.message || t('bo.aiPrompts.failedPublish'))
  }
}

const handleArchive = async (id) => {
  if (!confirm(t('bo.aiPrompts.confirmArchive'))) return
  try {
    await aiPromptService.archive(id)
    listRef.value?.loadPrompts()
  } catch (e) {
    alert(e.response?.data?.message || t('bo.aiPrompts.failedArchive'))
  }
}

const handleCreated = () => {
  showCreate.value = false
  listRef.value?.loadPrompts()
}

const handleUpdated = () => {
  editingId.value = null
  showingVersions.value = false
  listRef.value?.loadPrompts()
}
</script>

<style scoped>
.prompt-manager {
  padding: 2rem;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 0.25rem;
}

.page-header p {
  color: #6b7280;
  font-size: 0.875rem;
  margin: 0;
}

.btn-primary {
  padding: 0.625rem 1.25rem;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  transition: background 0.2s;
  white-space: nowrap;
}

.btn-primary:hover {
  background: #2563eb;
}
</style>
